module.exports = __webpack_public_path__ + "img/C3_HQ.092f2155.jpg";